<template>
  <div id="punch-card-view-toggle" class="d-inline-flex align-items-center">
    <b-button id="button-punch-card-gallery-view" class="p-0 border-0 mx-1 bg-transparent shadow-none"
      @click="setListView('gallery')">
      <ListGalleryView :isActive="isViewActive('gallery')" />
    </b-button>
    <b-button id="button-punch-card-table-view" class="p-0 border-0 mx-1 bg-transparent shadow-none"
      @click="setListView('table')">
      <ListTableView :isActive="isViewActive('table')" />
    </b-button>
    <b-button id="button-punch-card-deck-view" class="p-0 border-0 mx-1 bg-transparent shadow-none"
      @click="setListView('deck')">
      <ListDeckView :isActive="isViewActive('deck')" />
    </b-button>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import ListGalleryView from "./list-view-icons/ListGalleryView.vue";
import ListTableView from "./list-view-icons/ListTableView.vue";
import ListDeckView from "./list-view-icons/ListDeckView.vue";

export default {
  components: { ListGalleryView, ListTableView, ListDeckView },
  computed: {
    ...mapFields("punchCard", ["list_view"])
  },
  methods: {
    isViewActive(view) {
      return this.list_view === view;
    },
    setListView(view) {
      this.list_view = view;
    }
  }
}
</script>

<style lang="scss">
#punch-card-view-toggle>button {
  height: unset;
  font-size: unset;
}
</style>
